document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.blog-tabs .pix-container');
  if (!grid) return;

  const slideCount = grid.querySelectorAll('.pix-slide').length;

  function getCurrentSlidesPerView() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }

  function shouldAutoplay() {
    return slideCount > getCurrentSlidesPerView();
  }

  function init() {
    const section = grid.closest('.blog-tabs');
    if (section && slideCount <= 3) section.classList.add('blog-tabs--no-arrows');

    const swipix = new Swipix({
      container: '.blog-tabs .pix-container',
      infiniteLoop: slideCount > 3,
      autoplay: {
        enabled: shouldAutoplay(),
        delay: 4000,
        pauseOnInteraction: true,
        pauseAfterInteraction: false,
      },
      gap: 20,
      slidesPerView: { default: 1, 768: 2, 1024: 3 },
      nextButton: '.blog-tabs__next',
      prevButton: '.blog-tabs__prev',
      speed: 400,
    }).init();

    window.addEventListener('resize', () => {
      swipix.updateConfig({ autoplay: { enabled: shouldAutoplay() } });
    });
  }

  const link = document.querySelector('link[href*="blog-tabs.css"]');
  if (!link || link.sheet) {
    init();
  } else {
    link.addEventListener('load', init);
  }
});
